// components/Modal.jsx
import { useModalStore } from '@/hooks/useModalStore';

const Modal = () => {
  const { isOpen, content: Content, props, closeModal } = useModalStore();

  if (!isOpen || !Content) return null;

  return (
    <div className="fixed inset-0 z-[99999] grid place-content-center bg-black/70 backdrop-blur-sm" onClick={closeModal}>
      <div
        className="relative max-h-[90vh] max-w-[90vw] overflow-auto rounded-lg bg-background shadow-2xl"
        onClick={e => e.stopPropagation()}
      >
        <Content {...props} closeModal={closeModal} />
      </div>
    </div>
  );
};

export default Modal;
